import React, { useEffect, useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { achievementAPI, trainerAPI } from '../../api/services';

const AchievementsAdmin = () => {
  const [trainers, setTrainers] = useState([]);

  useEffect(() => {
    trainerAPI.getAll()
      .then(res => setTrainers(res.data?.data || []))
      .catch(err => console.error("Failed to fetch trainers", err));
  }, []);

  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { 
      key: 'description', 
      label: 'Description', 
      render: (item) => (
        <div className="tooltip-container">
          <div style={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {item.description || '—'}
          </div>
          {item.description?.length > 40 && <span className="tooltip-text">{item.description}</span>}
        </div>
      ) 
    },
    { key: 'trainerName', label: 'Trainer' },
    { key: 'mediaUrl', label: 'Image', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 6 }} /> : '—' },
  ];

  const FORM_FIELDS = [
    { name: 'name', label: 'Achievement Name', placeholder: 'Gold Medal Boxing' },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Details about this achievement...' },
    { 
      name: 'trainerId', 
      label: 'Trainer', 
      type: 'select', 
      options: trainers.map(t => ({ label: t.fullName, value: t.id })) 
    },
    { name: 'mediaId', label: 'Achievement Image', type: 'file' },
  ];

  return (
    <CrudTable
      title="Achievements"
      entityName="Achievement"
      columns={COLUMNS}
      formFields={FORM_FIELDS}
      fetchData={async () => {
        const res = await achievementAPI.getAll();
        return res.data?.data || [];
      }}
      onAdd={(data) => achievementAPI.add(data)}
      onUpdate={(id, data) => achievementAPI.update(id, data)}
      onDelete={(id) => achievementAPI.delete(id)}
    />
  );
};

export default AchievementsAdmin;
